var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.97368 9.90195H2.76316V17.602H4.97368V9.90195ZM11.6053 9.90195H9.39474V17.602H11.6053V9.90195ZM21 19.802H0V22.002H21V19.802ZM18.2368 9.90195H16.0263V17.602H18.2368V9.90195ZM10.5 2.48795L16.2584 5.50195H4.74158L10.5 2.48795ZM10.5 0.00195312L0 5.50195V7.70195H21V5.50195L10.5 0.00195312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksIcon);
export default __webpack_public_path__ + "static/media/books_icon.91f4dcf50b38ea59d4849c3b3f2e159d.svg";
export { ForwardRef as ReactComponent };